<template>
<DropdownModal
  :active.sync="_active"
  @update:active="n => {
    if (n === true) {
      $nextTick(() => $refs['city-search-input'].focus())
    }
  }"
  strategy="fixed"
  :offset="[0, 16]"
  :arrow="true"
>
  <template #toggle>
    <slot
      name="toggle"
      :active-city="activeCity"
    ></slot>
  </template>
  <template #content>
    <div class="city-select__dropdown">
      <VueSelect
        v-if="$store.state.store.cities.length !== 0"
        :value="$store.state.store.cities.find(
          c => c.id === $store.state.store.activeCityId
        )"
        @input="$store.dispatch('store/saveActiveCity', $event.id)"
        :options="$store.state.store.cities"
        key="id"
        label="name"
        autocomplete="address-level2"
        ref="city-select"
        @search:blur="_active = false"
      >
        <!-- Similar to `DeliveryAddressInput.vue`. -->
        <template #selected-option-container><div v-show="false"></div></template>
        <template #search="props">
          <input
            class="form-control"
            v-bind="props.attributes"
            v-on="props.events"
            placeholder="Найти город"
            ref="city-search-input"
            @mousedown.stop
            @click.stop
          >
        </template>
        <template #no-options>Ничего не найдено</template>
      </VueSelect>
      <p v-else>...</p>
    </div>
  </template>
</DropdownModal>
</template>

<script>
import { mapGetters } from 'vuex'
import DropdownModal from '@/components/modals/DropdownModal'
import VueSelect from 'vue-select';

export default {
  components: {
    DropdownModal,
    VueSelect,
  },
  props: {
    active: Boolean,
  },
  computed: {
    ...mapGetters({
      activeCity: 'store/activeCity',
    }),
    _active: {
      get() { return this.active; },
      set(v) { this.$emit('update:active', v); },
    }
  },
}
</script>

<style lang="less">
.city-select__dropdown {
  @apply p-5
    text-dark; // So header styles don't override it (e.g. when the sidebar background is dark).
  .v-select {
    .vs__dropdown-menu {
      @apply mt-3 overflow-auto;
      max-height: theme('width.64');
      .vs__dropdown-option {
        @apply p-2 font-light text-sm;
        &--highlight {
          @apply bg-primary-lightest;
        }
        &--selected {
          @apply text-white bg-primary;
        }
      }
    }
    .vs__actions {
      @apply hidden;
    }
  }
}
</style>
